import script from "./all_users.vue?vue&type=script&setup=true&lang=js"
export * from "./all_users.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__